/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

let UTC_hours = new Date().getUTCHours();
let hoursNow = UTC_hours+3

if( hoursNow >= 22 || hoursNow < 8) {
    let buttons = document.getElementsByClassName('c-btn c-btn--full c-btn--primary cart__checkout');
    //$(buttons.checkout).prop("disabled", true);
    // alert(buttons);
    // console.log(buttons.checkout);
}



/*
 function checkButton()
{
    if ((thisTime >=9 && thisTime<=24) && (thisDay>=15 && thisDay<=16)) 
    {
        $("#add").prop("disabled", true);
    }
    printAlert();

}

function printAlert() {
    window.alert('We are not accepting entries right now.');
}
*/